'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validation = require('utils/validation');

var _formValidation = require('helpers/formValidation');

var _formValidation2 = _interopRequireDefault(_formValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by nkrasnov on 16/09/16.
 * Copyright © 2016 Citronium. All rights reserved.
 */

var validate = (0, _validation.createValidator)({
  artistName: _formValidation2.default.field,
  title: _formValidation2.default.field,
  expiryDate: _formValidation2.default.field
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectInfo/ProjectInfoFormValidation.js
// module id = 2195
// module chunks = 1